<template>
  <div class="container">
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { RouterView } from 'vue-router'
import { onBeforeMount, onMounted } from 'vue'

onBeforeMount(() => {
  // Set web app title
  document.title = import.meta.env.VITE_APP_BRAND_NAME
})

onMounted(() => {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight * 0.01
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})
</script>

<style scoped>
@import 'tailwindcss' reference;

.container {
  @apply m-auto flex;
  max-width: 480px;
  height: 100vh; /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
}
</style>
